'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatBold = function MdFormatBold(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.5 25.9c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5h-5.9v5h5.9z m-5.9-15v5h5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5h-5z m9.4 7.1c2.2 1 3.6 3.2 3.6 5.7 0 3.5-2.7 6.3-6.2 6.3h-11.8v-23.4h10.5c3.8 0 6.6 3 6.6 6.8 0 1.7-1 3.5-2.7 4.6z' })
        )
    );
};

exports.default = MdFormatBold;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-bold.js
// module id = 1035
// module chunks = 36573943044255 79611799117203 213534597649335